import { useEffect } from 'react';
import { attachItemTooltipById64, ensureItemTooltipReady } from '@/lib/itemTooltipBridge';

/** Hover de ítems por data-id64 — compartido entre drop log y otros módulos. */
export function useItemTooltipHover(active: boolean, dependencyKey: string): void {
  useEffect(() => {
    if (!active) return;

    let cancelled = false;
    let cleanup: (() => void) | undefined;

    void (async () => {
      try {
        await ensureItemTooltipReady();
      } catch {
        return;
      }
      if (cancelled) return;
      cleanup = attachItemTooltipById64();
    })();

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, [active, dependencyKey]);
}
